import React from 'react';

import CardDialog from '~/components/CardDialog';
import CliveRelatedCmsFeatureFlagsTable from '~/components/SystemConfiguration/CliveConfiguration/CliveFeatureFlagsTab/CliveRelatedCmsFeatureFlagsTable';
import ConfigurationScreenWithTabs from '~/components/SystemConfiguration/ConfigurationScreenWithTabs';
import OperationsBreadcrumbs from '~/components/SystemConfiguration/OperationsBreadcrumbs';
import { DemoClaimsConfiguration } from '~/components/SystemConfiguration/Tabs/DemoConfiguration/DemoClaimsConfiguration';
import CliveDemoManagementTab from '~/components/SystemConfiguration/Tabs/DemoConfiguration/DemoManagementTab';
import { ADMIN_ROUTES } from '~/routesConstants';

const CliveDemoFFComponent: React.FC = () => {
  return (
    <CliveRelatedCmsFeatureFlagsTable
      additionalFilter={(feature) =>
        (feature.display_name.toLowerCase() + feature.description.toLowerCase()).includes('demo')
      }
      withDemoFeaturesSwitch={false}
    />
  );
};

export const DemoConfigurationTabInternal: React.FC = () => {
  const tabs = [
    {
      label: 'Claims',
      url: ADMIN_ROUTES.DEMO_CONFIGURATION.CLAIMS,
      component: DemoClaimsConfiguration,
      isEnabled: true,
    },
    {
      label: 'Clive Demo FF',
      url: ADMIN_ROUTES.DEMO_CONFIGURATION.CLIVE_DEMO_FEATURE_FLAGS,
      component: CliveDemoFFComponent,
      isEnabled: true,
    },
    {
      label: 'Clive Demo Management',
      url: ADMIN_ROUTES.DEMO_CONFIGURATION.CLIVE_DEMO_CONFIGURATION,
      component: CliveDemoManagementTab,
      isEnabled: true,
    },
  ];

  return (
    <CardDialog noCardTitle>
      <OperationsBreadcrumbs currentTab="Clive Configuration" />
      <ConfigurationScreenWithTabs
        tabs={tabs}
        title="Demo Configuration"
        operationTabName="Demo Configuration"
        subtitle=""
      />
    </CardDialog>
  );
};
